import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-pdf-viewer-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './pdf-viewer-dialog.component.html',
  styleUrls: ['./pdf-viewer-dialog.component.scss'],
})
export class PdfViewerDialogComponent {
  pdfUrl: SafeResourceUrl;
  invoiceId: number;

  constructor(
    public dialogRef: MatDialogRef<PdfViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { pdfUrl: string; invoiceId: number },
    private sanitizer: DomSanitizer,
  ) {
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.pdfUrl);
    this.invoiceId = data.invoiceId;

    /* La superficie del dialog e' un ANTENATO di questo componente (vive
       nell'overlay CDK), quindi il suo contorno e il padding azzerato che fa
       arrivare il documento a filo dei bordi non sono raggiungibili da uno
       stile incapsulato: servono le regole globali di
       .izy-viewer-dialog-panel. La classe la aggiunge il componente e non i
       chiamanti perche' i punti di apertura sono tre e la veste
       dell'anteprima e' la stessa per tutti. */
    this.dialogRef.addPanelClass('izy-viewer-dialog-panel');
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
